import '@mantine/core/styles.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import r2wc from 'react-to-webcomponent'

import { TariffCalculator } from '~/widgets/TariffCalculator/TariffCalculator'

// Create the web component
const TariffCalculatorWebComponent = r2wc(TariffCalculator, React, ReactDOM, {
  props: {
    title: 'string',
    width: 'string',
    height: 'string',
    className: 'string',
    // Add your custom props here
  },
})

// Register the custom element
if (!customElements.get('tariff-calculator')) {
  customElements.define('tariff-calculator', TariffCalculatorWebComponent)
}

// Export for direct React usage if needed
export { TariffCalculator, TariffCalculatorWebComponent }

// For UMD builds, also expose on window
if (typeof window !== 'undefined') {
  ;(
    window as unknown as {
      TariffCalculator: typeof TariffCalculatorWebComponent
    }
  ).TariffCalculator = TariffCalculatorWebComponent
}
